export function constructDropdownValue(admin) {
  return {
    value: admin,
    label: admin && admin.email && admin.fullName ? `${admin.fullName} (${admin.email})` : "",
  }
}
